export const CUSTOMER_TOKEN_KEY = 'customerToken';

export const getCustomerToken = () => localStorage.getItem(CUSTOMER_TOKEN_KEY) || '';

export const setCustomerToken = (token = '') => {
  if (token) localStorage.setItem(CUSTOMER_TOKEN_KEY, token);
};

export const clearCustomerToken = () => {
  localStorage.removeItem(CUSTOMER_TOKEN_KEY);
};

export const isCustomerAuthenticated = () => Boolean(localStorage.getItem(CUSTOMER_TOKEN_KEY));
